import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_BACKEND_RENDIMENTOS_URL || "https://wlbe-rendimentos-dev.velotax.com.br",
});

export default api;
